import { Component, Inject, Input, OnInit, ViewEncapsulation,Output,EventEmitter  } from '@angular/core';
import { ActivatedRoute, Router,RouterModule, Routes } from '@angular/router';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { DwModalService, DwMessageService } from 'ng-quicksilver';
import { trigger,state,style,animate,transition, query } from '@angular/animations';
import {
  IDwLanguageList, DwUserService, LocalStorage, DwUserStorage, DwLanguageListService,
  APP_DEFAULT, DW_USING_TAB, DwLanguageService, DW_MULTI_TENANT, DwRoutingMessageService, DwAuthService
} from "@webdpt/framework";
import {FxDapHttpClient} from '../../../shared/fx-http-client';
import { HttpClient } from '@angular/common/http';

import { ForgetComponent } from '../../forget/forget.component';
import { Logo_Path, IDwForgetverificationType } from '@webdpt/framework';
import { ElementRef} from '@angular/core';
import { FxUserInfoService } from 'app/implementation/auth/fx-auth/fx-user-info.service';
import { TranslateService } from '@ngx-translate/core';
import { MallService } from 'app/implementation/programs/mall/mall.service';
// E:\quwj\FX\shop\projects\webdpt\framework\auth\user-storage.ts
// import { DwUserStorage } from './user-storage';


@Component({
  selector: 'fx-login-block',
  templateUrl: './login-block.component.html',
  styleUrls: ['./login-block.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('flyInOut', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(10%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(-10%)' }))
      ])
    ])
  ]
})

export class FxLoginBlockComponent implements OnInit {
  @Input() modalScope: any;  // 登陆开窗
  @Output() dataEvent = new EventEmitter<boolean>();
  language: string; // 语言
  //remember_me: boolean; // 记住我
  languageList: IDwLanguageList[]; // 取可用語言清單
  captchaDataMap = { image_value: '', public_key: '', isCaptcha: false};  //验证码
  user = { ent: '', userId: '', password: '', captchaKey: {}}; // 使用者应输入
  validateForm: FormGroup;
  returnUrl: string;
  public isDisabled: boolean = false; // 是否允許按送出.
  public showCaptcha: boolean = false; // 是否使用验证码
  c_E020:string; //登录验证码条件,1.不启用，2.登录输入验证码，3.密码输入错误后需输入验证码
  c_E022:string; //第一次登录是否强制修改密码 1.不控制，2.提醒，3.强制修改
  c_S001:string = ''; //系统预设企业编号
  image_data:string; //base64图片
  systemKeys = [];    //系统参数
  keys = [];          //集团参数
  public isPassword = false;
  showPassword: boolean = false;      // 输入密码是否使用明文显示

  public isFouce:any;
  verificationType: Array<IDwForgetverificationType> = [];
  //public myGroup: FormGroup;
  public myGroup = new FormGroup({
    language: new FormControl()
 });

  @Input() showRemember: boolean;
  @Input() showLanguage: boolean;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private fBuilder: FormBuilder,
    private dwModalService: DwModalService,
    private authService: DwAuthService,
    private userService: DwUserService,
    private fxUserService: FxUserInfoService,
    private storage: LocalStorage,
    private userStorage: DwUserStorage,
    private languageListService: DwLanguageListService,
    private languageService: DwLanguageService,
    public http: HttpClient,
    public dwMessage: DwRoutingMessageService,
    private el:ElementRef,
    private translateService: TranslateService,
    public mallService: MallService, // 当前响应式平台
    @Inject(APP_DEFAULT) private defaultApp: any,
    @Inject(DW_USING_TAB) private _usingTab: boolean,
    @Inject(DW_MULTI_TENANT) public dwMultiTenant: boolean,
    @Inject(Logo_Path) public dwLogoPath: string
  ) {

  }

  /**
   * form 验证按钮
   */
  submitForm(): void {
    for (const i in this.validateForm.controls) {
      if (this.validateForm.controls.hasOwnProperty(i)) {
        this.validateForm.controls[i].markAsDirty();
      }
    }
  }


  /**
   * 登入
   */
  login(): void {
    console.log(this.modalScope);
    if(this.showCaptcha){
      console.log('验证码',this.validateForm.get('captchaKey').value);
      this.captchaDataMap.image_value = this.validateForm.get('captchaKey').value?this.validateForm.get('captchaKey').value:'';
      this.captchaDataMap.isCaptcha = true;
    }else{

    }

    this.user = {
      ent: this.validateForm.get('ent').value,
      userId: this.validateForm.get('userId').value,
      password: this.validateForm.get('password').value,
      captchaKey:this.captchaDataMap
    };

    this.authService.login(this.user).subscribe(
      data => {
        console.log("data:",data);
        if (!data.success) {
          //登录服务已经有提示了
          /*this.dwModalService.error({
            dwContent: data.description,
          });*/
          if(this.c_E020 === '3'){
            this.showCaptcha = true;
            console.log('账密错误，需要输入验证码xxxxxx');
          }
          return;
        }else{
          //用户是第一次登陆
          if(data.isFirstLogin){
            console.log("用户第一次登陆=======");
            if(this.c_E022 === '1'){
              //不控制
            }else if(this.c_E022 === '2'){
              //提醒
              this.dwMessage.warning("首次登陆系统，请重置密码");
            }else if(this.c_E022 === '3'){
              //强制修改密码，跳转到修改密码画面
            }
          }
        }

        console.log('调用登录后的data:',data);
        console.log('登录成功啦');

        this.afterLogin()
        // // 在開出登入事件接口前，暫時的FineReport SSO 代碼
        // if (this.usingFrSSO) {
        //   const url = `${this.frUrl}?op=fs_load&cmd=sso&fr_username=${this.user.userId}&fr_password=${data.token}`;
        //   this.http.jsonp(url, 'callback').subscribe();
        // }
      },(error:any) => {
        if(this.c_E020 === '3'){
          this.showCaptcha = true;
          console.log('账密错误，需要输入验证码xxxxxx');
        }
      }

    );
  }

  /**
   * 没有使用 iam api 时取 mock 资料
   * 有其他登入链结应修正 loginservice 中的 getUserInfo()
   */
  public afterLogin(): void {
    const user_id = this.validateForm.get('userId').value;
    const ent = this.validateForm.get('ent').value;
    this.fxUserService.read(user_id, ent).subscribe(
      data => {
        if (!data['success']) {
          this.dwModalService.error({
            dwContent: data['description'],
          });
          return;
        }

        //const remember = this.validateForm.get('remember').value;

        //const tenantId = (remember) ? this.validateForm.get('tenantId').value : '';
        //const userId = (remember) ? this.validateForm.get('userId').value : '';
        //const userName = (remember) ? data['userInfo']['userName'] : '';

        //this.storage.set('rememberLogin', remember);
        //this.storage.set('tenantId', tenantId);
        //this.storage.set('userId', userId);
        //this.storage.set('userName', userName);

        // FineReport 的 SSO login, 因為需要傳 tenantId, 所以只能寫在 getUserInfo/read 之後.
        //this.authService.fineReportlogin();

        // 更新语系
        this.languageService.setDefaultLang(this.fxUserService.userInfo['c_lang']);
        this.languageService.setUp(this.fxUserService.userInfo['c_lang']);
        // 关闭登陆的弹框
        this.modalScope.dwModalService.closeAll();
        // login 後的導頁.
        this.mallService.reloadCurrentUrl();
      }, error => {
        console.log(error);
      }
    );
  }

  // 获取url参数
  getUrlParams(): Observable<any> {
    return new Observable((observer) => {
      this.route.queryParams.subscribe(params => {
        let queryParams = JSON.parse(JSON.stringify(params))
        observer.next(queryParams);
        observer.complete();
      })
    })
  }
  /**
   * todo 目前寫在 2 個地方, 應該集中到 dw-tab-routing 去.
   * [登入後]的要導頁的 url.
   *
   * param {string} returnUrl: 導頁的 url.
   */
  public loginedForwardUrl(returnUrl: string): void {
    if (!this._usingTab) {
      this.router.navigateByUrl(returnUrl);
      return;
    }

    if (!returnUrl || returnUrl === '/') {
      this.router.navigateByUrl('/dwTabRouting');
      return;
    }

    if (returnUrl.search('/dwTabRouting') === -1) {
      if (returnUrl.substr(0, 1) !== '/') {
        returnUrl = '/' + returnUrl;
      }
      returnUrl = '/dwTabRouting' + returnUrl;
      this.router.navigateByUrl(returnUrl);
      return;
    }

    this.router.navigateByUrl(returnUrl);
  }



  /**
   * 翻译 function
   *
   */
  public switchLanguage(language: string): void {
    this.languageService.setUp(language);
  }


  ngOnInit(): void {
   console.log( this.el.nativeElement.parentNode );
    // 存在 storage 可能為字串, 需轉型成 boolean;
    //const remember = JSON.parse(this.storage.get('rememberLogin')) ? JSON.parse(this.storage.get('rememberLogin')) : false;
    const language = this.languageService.currentLanguage;
    //const sTenantId = this.storage.get('tenantId') ? this.storage.get('tenantId') : '';
    //const sAccount = this.storage.get('userId') ? this.storage.get('userId') : '';
    const ent = this.userStorage.get('DwFxed020EntInfo');
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || this.defaultApp;

    // tenantId 的驗證.
    // const tenantIdValidators = (this.dwMultiTenant) ? [Validators.required] : [];

    this.validateForm = this.fBuilder.group({
      //tenantId: [sTenantId, tenantIdValidators],
      // ent: [null, [Validators.required]],
      ent: [ent],
      userId: [null, [Validators.required]],
      password: [null, [Validators.required]],
      captchaKey: [null],
      language: [language, [Validators.required]],
      //remember: [null]
    });

    // 顯示下拉語系.
    this.languageListService.getLanguagesList().subscribe(
      (list: IDwLanguageList[]) => {
        this.languageList = list;
      }
    );

    // 切換語系.
    this.validateForm.controls.language.valueChanges.subscribe(
      (value: string) => {
        this.switchLanguage(value);
      }
    );
    // 取得最新語言別
    this.languageService.language$.subscribe(
      lang => {
        this.language = lang;
      }
    );

    //获取系统参数
    this.systemKeys = ['c_S001'];
    this.http.post('A/IACommonService/pub_upd_aas', {
      param: this.systemKeys
    }).subscribe((response: any) => {
      console.log('pub_upd_aas response:', response);
      console.log('response.data response:', response.data);

      if(!response.success){
        this.dwMessage.error(response.message);
        return;
      }

     response.data.forEach(element => {
      if(element.aas001 === 'c_S001'){
        this.c_S001 = element.aas002;
        if (!ent) {
          this.validateForm.get('ent').setValue(this.c_S001);
          console.log('系统参数c_S001：'+this.c_S001);
        }
      }
     });

      //获取集团参数
      this.keys = ['c_E020','c_E022'];

      this.http.post('A/IACommonService/pub_upd_aat', {
        param: this.keys,aatent:this.c_S001
      }).subscribe((response: any) => {
        console.log('pub_upd_aat response:', response);
        console.log('response.data response:', response.data);

        if(!response.success){
          this.dwMessage.error(response.message);
        }

      response.data.forEach(element => {
        if(element.aat001 === 'c_E020'){
          this.c_E020 = element.aat002;
          //根据c_E020判断是否要启用验证码
          if(this.c_E020 === '1'){
            this.showCaptcha = false;
          }else if(this.c_E020 === '2'){
            this.showCaptcha = true;
          }else if(this.c_E020 === '3'){
            this.showCaptcha = false;
          }
        }else if(element.aat001 === 'c_E022'){
          this.c_E022 = element.aat002;
        }
      });

      },(error:any) => {
        console.log('error:',error);
        this.dwMessage.error(error.error.errorMessage);
      });

    },(error:any) => {
      console.log('error:',error);
      this.dwMessage.error(error.error.errorMessage);
    });

    //获取验证码
    this.http.post('A/ILoginService/getCaptchaData', {
    }).subscribe((response: any) => {
      console.log('getCaptchaData response:', response);

      this.image_data = 'data:image/png;base64,' + response.image_data;
      this.captchaDataMap.public_key = response.public_key;

    },(error:any) => {
      console.log('error:',error);
      this.dwMessage.error("获取验证码错误");

    });

    this.verificationType = [
      IDwForgetverificationType.EMAIL,
      IDwForgetverificationType.MOBILEPHONE
    ];
  }
  // 忘記密碼.
  // forget(): void {
  //   this.router.navigateByUrl('/forget');
  // }

  /**
   * 获取验证码
   */
  reloadVerifyImage(): void {
    console.log('刷新验证码');
    //获取验证码
    this.http.post('A/ILoginService/getCaptchaData', {
    }).subscribe((response: any) => {
      console.log('getCaptchaData response:', response);
      console.log('this.image_data:', this.image_data);
      this.image_data = 'data:image/png;base64,' + response.image_data;
      this.captchaDataMap.public_key = response.public_key;
      console.log('response.image_data response:', response.image_data);
      console.log('response.public_key response:', response.public_key);

    },(error:any) => {
      console.log('error:',error);
      this.dwMessage.error("获取验证码错误");
    });
  }

  //获取集团参数
  getParameter(): void {
    alert('进入集团参数');
    //获取集团参数
    //this.keys = ['c_E020','c_E022'];

    this.http.post('A/IACommonService/pub_upd_aat', {
      param: this.keys,aatent:this.validateForm.get('ent').value
    }).subscribe((response: any) => {
      console.log('pub_upd_aat response:', response);

      console.log('response.data response:', response.data);

      if(!response.success){
        this.dwMessage.error(response.message);
      }

     response.data.forEach(element => {
      if(element.aat001 === 'c_E020'){
        this.c_E020 = element.aat002;
        //根据c_E020判断是否要启用验证码
        if(this.c_E020 === '1'){
          this.showCaptcha = false;
        }else if(this.c_E020 === '2'){
          this.showCaptcha = true;
        }else if(this.c_E020 === '3'){
          this.showCaptcha = false;
        }
      }else if(element.aat001 === 'c_E022'){
        this.c_E022 = element.aat002;
      }
     });

    },(error:any) => {
      console.log('error:',error);
      this.dwMessage.error(error.error.errorMessage);
    });
  }

  //输入框动画
  isBorder(e) {
    this.isFouce = e;
    console.log(this.isFouce)
  }

  // 注册
  onRegister(): void {
    // 关闭登陆的弹框
    this.modalScope.dwModalService.closeAll();
    // 跳转到注册页面
    this.router.navigate(['mall/mallagent']);
  }

  //忘记密码
  forgetP() {
    if(!this.validateForm.get('userId').value){
      this.dwMessage.errorNew(this.translateService.instant('fxed020-set-user'), '', '', '',)
      return;
    }
    if(this.isPassword) {
      this.isPassword = false;
    } else {
      this.isPassword = true;
    }
    this.dataEvent.emit(this.isPassword);
  }
  onCancel() {
    //alert('321')
    // console.log(e);
    // if(e == 'cancle') {
    //   this.isPassword = false;
    // }
    this.isPassword = false;
    this.dataEvent.emit(this.isPassword);
  }


}
